import { StatementLinesModel } from "@bToC/Services/GerrieApiModels";
import { getStatementLines, GetStatementLinesApiParameter } from "@bToC/Services/StatementService";
import { CustomActions, CustomState } from "@bToC/Store/Reducers";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<
    GetStatementLinesApiParameter,
    StatementLinesModel,
    {
        apiCallIsSuccessful: boolean;
        getState: () => CustomState;
    } & DispatchProp<CustomActions>
>;

export const DispatchBeginLoadStatementLines: HandlerType = props => {
    props.dispatch({
        type: "Data/Statement/BeginLoadStatementLines",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getStatementLines(props.apiParameter);
};

export const DispatchCompleteLoadStatementLines: HandlerType = props => {
    props.dispatch({
        type: "Data/Statement/CompleteLoadStatementLines",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [PopulateApiParameter, DispatchBeginLoadStatementLines, RequestDataFromApi, DispatchCompleteLoadStatementLines];

export const loadStatementLines = createHandlerChainRunner(chain, "LoadStatementLines");
export default loadStatementLines;
